import { isValidElement } from "react";
import { validateTidalLicense } from "../../base/index.js";
import { isPlainObject } from "../isPlainObject.js";
function deepClone(source) {
  if (isValidElement(source) || !isPlainObject(source)) {
    return source;
  }
  const output = {};
  Object.keys(source).forEach((key) => {
    output[key] = deepClone(source[key]);
  });
  return output;
}
function deepmerge(target, source, options = { clone: true }) {
  const output = options.clone ? { ...target } : target;
  if (isPlainObject(target) && isPlainObject(source)) {
    Object.keys(source).forEach((key) => {
      if (isValidElement(source[key])) {
        ;
        output[key] = source[key];
      } else if (isPlainObject(source[key]) && // Avoid prototype pollution
      Object.prototype.hasOwnProperty.call(target, key) && isPlainObject(target[key])) {
        ;
        output[key] = deepmerge(target[key], source[key], options);
      } else if (options.clone) {
        ;
        output[key] = isPlainObject(source[key]) ? deepClone(source[key]) : source[key];
      } else {
        ;
        output[key] = source[key];
      }
    });
  }
  return output;
}
validateTidalLicense();
export {
  deepmerge
};
//# sourceMappingURL=deepmerge.js.map
